// Translations for ServicePlyus website - Uzbek and Russian

export const translations = {
  uz: {
    // Navbar
    nav: {
      home: "Bosh sahifa",
      about: "Biz haqimizda",
      services: "Xizmatlar",
      contact: "Aloqa",
      boilers: "Katyollar"
    },
    
    // Common
    common: {
      callNow: "Hozir qo'ng'iroq qilish",
      onlineRequest: "Onlayn ariza qoldirish",
      learnMore: "Batafsil",
      orderNow: "Hozir buyurtma qilish",
      callMaster: "Ustani chaqirish",
      submitRequest: "Ariza yuborish",
      freeConsultation: "Bepul konsultatsiya olish",
      telegram: "Telegram",
      instagram: "Instagram"
    },

    // Home Page
    home: {
      heroTitle: "Katyol remont va texnik xizmat",
      heroSubtitle: "Toshkent bo'ylab tez va ishonchli katyol ta'mirlash xizmati",
      heroDescription: "Barcha turdagi katyollarni professional ta'mirlash, diagnostika va texnik xizmat ko'rsatish",
      averageRepairTime: "O'rtacha ta'mirlash vaqti 25-30 daqiqa",
      paymentAfterRepair: "To'lov faqat ta'mirlashdan keyin",
      discountWebsite: "Sayt orqali buyurtmada 10% chegirma",
      
      advantagesTitle: "Nega aynan biz?",
      advantagesSubtitle: "ServicePlyus - katyol ta'mirlashda sizning ishonchli hamkoringiz",
      
      advantage1Title: "Katta tajriba",
      advantage1Desc: "10+ yillik tajriba bilan barcha turdagi katyollarni ta'mirlaymiz",
      advantage2Title: "Kafolat xizmati",
      advantage2Desc: "Barcha ishlarimizga 6 oylik kafolat beramiz",
      advantage3Title: "Tezkor xizmat",
      advantage3Desc: "24/7 ish tartibi, arizangizga 1 soat ichida javob beramiz",
      advantage4Title: "Adolatli narxlar",
      advantage4Desc: "Bozordagi eng maqbul narxlarda sifatli xizmat",
      
      brandsTitle: "Qaysi katyollarni ta'mirlaymiz",
      brandsSubtitle: "Barcha mashhur brendlarni professional ta'mirlash va texnik xizmat",
      brandsMore: "Va boshqa ko'plab brendlar...",
      
      ctaTitle: "Katyolni bugundan boshlab ta'mirlang!",
      ctaSubtitle: "10+ yillik tajriba, professional yondashuv, kafolat xizmati. Bizga ishongan minglab mijozlar bunga guvoh!",
      
      stats1: "1000+",
      stats1Label: "Mamnun mijozlar",
      stats2: "24/7",
      stats2Label: "Ishlash vaqti",
      stats3: "6 oy",
      stats3Label: "Kafolat muddati",
      
      // New Enhanced Sections
      pricingTitle: "Xizmatlar narxlari",
      pricingSubtitle: "Gaz katyollari ta'mirlash va texnik xizmat narxlari",
      
      // Detailed Service Pricing
      servicePricing: {
        diagnostics: {
          name: "Diagnostika va profilaktika",
          price: "400,000 so'mdan",
          desc: "To'liq diagnostika va katyol holatini tekshirish"
        },
        cleaning: {
          name: "Katyol tozalash va sozlash",
          price: "450,000 so'mdan",
          desc: "Issiqlik almashinuvchini tozalash, yonish kamerasini tozalash"
        },
        threeWayValve: {
          name: "Uch yo'nalishli klapan almashtirish",
          price: "450,000 so'mdan",
          desc: "Asl ehtiyot qismlar bilan almashtirish"
        },
        turbine: {
          name: "Turb ventalyator almashtirish",
          price: "850,000 so'mdan",
          desc: "Chiqarish tizimi ta'mirlash"
        },
        heatExchanger: {
          name: "Issiqlik almashinuvchini almashtirish",
          price: "1,300,000 so'mdan",
          desc: "Yangi issiqlik almashinuvchi o'rnatish"
        },
        pressureSensor: {
          name: "Bosim sensori almashtirish",
          price: "250,000 so'mdan",
          desc: "Suv bosimi datchigi almashtirish"
        },
        manostat: {
          name: "Manostat almashtirish",
          price: "380,000 so'mdan",
          desc: "Havo bosimi datchigi almashtirish"
        },
        emergency: {
          name: "Shoshilinch ta'mirlash (24/7)",
          price: "Kelishuv asosida",
          desc: "Tezkor chiqish va muammoni bartaraf etish"
        }
      },
      
      // Trust Signals / Why Choose Us
      trustTitle: "Nega bizni tanlashadi?",
      trustSubtitle: "Bizning servis markazi Toshkentdagi eng yaxshisi",
      
      trust1Title: "Tezkor chiqish",
      trust1Desc: "Ustalar o'sha kuni keladi, 30-60 daqiqa ichida",
      trust2Title: "Bepul diagnostika",
      trust2Desc: "Mutaxassislar tezda katyol nosozligini aniqlay oladi",
      trust3Title: "24/7 ish tartibi",
      trust3Desc: "Servis markazimiz sizning qo'ng'irog'ingizni doim qabul qiladi",
      trust4Title: "Sifatli ta'mirlash",
      trust4Desc: "Qulay narxlarda ajoyib sifatli ta'mirlash",
      
      // Testimonials
      testimonialsTitle: "Mijozlar fikrlari",
      testimonialsSubtitle: "Biz yordam bergan baxtli mijozlarimizning fikrlari",
      
      testimonial1Name: "Alisher Karimov",
      testimonial1Role: "Uy egasi",
      testimonial1Text: "Kompaniyaga tezkorligi va professionallik uchun minnatdorchilik bildirmoqchiman. Ish sifatli va o'z vaqtida bajarildi. Endi menda yana qulay va ishonchli isitish tizimi bor!",
      
      testimonial2Name: "Dilnoza Rahimova",
      testimonial2Role: "Ofis menejeri",
      testimonial2Text: "Bu kompaniyaning mijozlarga e'tiborli munosabatini ta'kidlamoqchiman. Menga katyol ta'mirlashning optimal variantini tanlashda yordam berishdi, professional maslahat berishdi va yuqori sifatli ta'mirlashni amalga oshirishdi.",
      
      testimonial3Name: "Sardor Usmonov",
      testimonial3Role: "Tadbirkor",
      testimonial3Text: "Odatda sharh qoldirmayman, lekin bu yerda o'tib ketolmadim. Bu kompaniyada katyol ta'mirlashni buyurtma qildim va natijadan juda mamnunman. Bolalar aniq va ehtiyotkorlik bilan ishlashdi.",
      
      testimonial4Name: "Jahongir Toshmatov",
      testimonial4Role: "Qurilish kompaniyasi direktori",
      testimonial4Text: "ServicePlyus bilan ishlash - bu haqiqiy zavq. Mutaxassislar o'z ishini mukammal biladilar, barcha ishlar o'z vaqtida va sifatli bajariladi. Katyolimiz endi mukammal ishlayapti, qish mavsumida hech qanday muammo bo'lmadi.",
      
      testimonial5Name: "Madina Rahmonova",
      testimonial5Role: "Restoran egasi",
      testimonial5Text: "Restorandagi katyol buzilganda, ServicePlyus tezda yordam berdi. 24/7 xizmat - bu juda muhim. Ular kechqurun kelishdi va bir necha soatda muammoni hal qilishdi. Professional yondashuv va qulay narxlar. Tavsiya qilaman!",
      
      // Additional Services
      additionalServicesTitle: "Qo'shimcha xizmatlarimiz",
      service1: "Gaz katyollarini sozlash",
      service2: "Profilaktika ishlari va tozalash",
      service3: "Devordagi va poldagi katyollar xizmati",
      service4: "Ikki konturli katyollar xizmati",
      service5: "Gaz va suv sizishini tuzatish",
      service6: "Boshqaruv platasi ta'mirlash"
    },

    // About Page
    about: {
      title: "ServicePlyus haqida",
      subtitle: "ServicePlyus - Toshkent shahrida katyol ta'mirlash bo'yicha etakchi kompaniya. Bizning jamoamiz 10 yildan ortiq tajribaga ega professional ustalardan iborat.",
      
      featuresTitle: "Bizning afzalliklarimiz",
      feature1: "10+ yillik tajriba",
      feature2: "Malakali mutaxassislar jamoasi",
      feature3: "Barcha brendlarni ta'mirlash",
      feature4: "Kafolat xizmati",
      feature5: "24/7 qo'llab-quvvatlash",
      feature6: "Tezkor xizmat",
      
      whyUsTitle: "Nima uchun mijozlar bizni tanlaydi?",
      whyUsSubtitle: "Sifat, ishonchlilik va mijozlarga g'amxo'rlik - bizning asosiy tamoyillarimiz",
      
      whyUs1Title: "Professional yondashuv",
      whyUs1Desc: "Har bir mijozga individual yondashish va sifatli xizmat ko'rsatish",
      whyUs2Title: "Ishonchli xizmat",
      whyUs2Desc: "Mijozlarimizning 95% dan ortig'i bizni do'stlariga tavsiya qiladi",
      whyUs3Title: "Samarali yechimlar",
      whyUs3Desc: "Eng qisqa muddatda va optimal narxlarda muammolarni hal qilamiz",
      
      processTitle: "Qanday ishlash jarayoni?",
      processSubtitle: "Oddiy va samarali - 4 bosqichda muammoni hal qilamiz",
      
      process1Title: "Qo'ng'iroq",
      process1Desc: "Bizga qo'ng'iroq qiling yoki onlayn ariza qoldiring",
      process2Title: "Diagnostika",
      process2Desc: "Usta kelib, katyolni tekshiradi va muammoni aniqlaydi",
      process3Title: "Ta'mirlash",
      process3Desc: "Tezkor va sifatli ta'mirlash ishlari bajariladi",
      process4Title: "Kafolat",
      process4Desc: "Barcha ishlarga 6 oylik kafolat beramiz",
      
      ctaTitle: "Katyolni professional ustaga ishonib topshiring",
      ctaSubtitle: "Toshkent bo'ylab tezkor xizmat, ishonchli ta'mirlash va kafolat"
    },

    // Services Page
    services: {
      title: "Bizning xizmatlarimiz",
      subtitle: "Katyol ta'mirlash va texnik xizmatning barcha turlarini professional darajada amalga oshiramiz",
      
      service1Title: "Katyol diagnostikasi",
      service1Desc: "Katyolning ishdan chiqish sabablarini aniq aniqlash va to'liq diagnostika o'tkazish xizmati",
      service2Title: "Katyol ta'mirlash",
      service2Desc: "Barcha turdagi nosozliklarni tezkor va sifatli ta'mirlash, ishga tushirish",
      service3Title: "Ehtiyot qismlarni almashtirish",
      service3Desc: "Asl ehtiyot qismlar bilan ishonchli almashtirish xizmati",
      service4Title: "Yillik texnik xizmat",
      service4Desc: "Katyolni tozalash, sozlash va optimal ishlashini ta'minlash",
      service5Title: "O'rnatish va sozlash",
      service5Desc: "Yangi katyollarni professional o'rnatish va ishga tushirish",
      
      includesTitle: "Xizmatlarimiz nimalarni o'z ichiga oladi?",
      includesSubtitle: "Har bir xizmat to'liq va professional darajada amalga oshiriladi",
      
      include1Title: "Bepul diagnostika",
      include1Desc: "Katyolni to'liq tekshirish va muammoni aniqlash",
      include2Title: "Tezkor xizmat",
      include2Desc: "Arizangizga 1 soat ichida javob va tezkor ta'mirlash",
      include3Title: "Asl ehtiyot qismlar",
      include3Desc: "Faqat sertifikatlangan va original qismlar ishlatamiz",
      include4Title: "Professional ustalar",
      include4Desc: "10+ yillik tajribaga ega malakali mutaxassislar",
      include5Title: "Kafolat xizmati",
      include5Desc: "Barcha ta'mirlash ishlariga 6 oylik kafolat",
      include6Title: "Qulay narxlar",
      include6Desc: "Bozordagi eng maqbul va adolatli narxlar",
      
      pricingTitle: "Xizmat narxlari",
      pricingSubtitle: "Aniq narxlar diagnostikadan keyin aniqlanadi. Diagnostika bepul!",
      averagePrices: "O'rtacha narxlar",
      
      price1: "Diagnostika",
      price1Value: "Bepul",
      price2: "Tozalash va sozlash",
      price2Value: "300,000 so'mdan",
      price3: "Kichik ta'mirlash",
      price3Value: "400,000 so'mdan",
      price4: "Katta ta'mirlash",
      price4Value: "700,000 so'mdan",
      
      getPrice: "Aniq narxni bilib oling",
      getPriceDesc: "Har bir holat individual. Bepul diagnostikadan so'ng aniq narx va ish hajmini aytamiz.",
      
      ctaTitle: "Katyolni bugun ta'mirlang!",
      ctaSubtitle: "Qo'ng'iroq qiling va bepul diagnostika oling"
    },

    // Contact Page
    contact: {
      title: "Biz bilan bog'laning",
      subtitle: "Katyolni ta'mirlash uchun qo'ng'iroq qiling yoki ariza qoldiring. 24/7 xizmatdamiz!",
      
      contactInfo: "Aloqa ma'lumotlari",
      phoneTitle: "Telefon raqam",
      phoneSubtitle: "Hoziroq qo'ng'iroq qiling",
      
      locationTitle: "Xizmat hududi",
      locationText: "Xizmat faqat Toshkent shahri bo'yicha",
      locationSubtext: "Barcha tumanlar bo'yicha",
      
      hoursTitle: "Ish vaqti",
      hoursText: "24/7",
      hoursSubtext: "Dam olish kunlari ham ishlaymiz",
      
      socialTitle: "Ijtimoiy tarmoqlarda",
      
      formTitle: "Ariza qoldiring",
      formSubtitle: "Arizangizni qoldiring, biz tez orada siz bilan bog'lanamiz",
      
      nameLabel: "Ismingiz",
      namePlaceholder: "To'liq ismingizni kiriting",
      phoneLabel: "Telefon raqam",
      phonePlaceholder: "+998 90 123 45 67",
      
      submitting: "Yuborilmoqda...",
      submitButton: "Ariza yuborish",
      submitNote: "Arizangizni yuborganingizdan so'ng, biz 15 daqiqa ichida siz bilan bog'lanamiz",
      
      quickCall: "Yoki to'g'ridan-to'g'ri qo'ng'iroq qiling",
      
      banner1: "1 soat",
      banner1Label: "Javob berish vaqti",
      banner2: "24/7",
      banner2Label: "Doim xizmatdamiz",
      banner3: "Bepul",
      banner3Label: "Diagnostika xizmati",
      
      // Lead Form
      leadFormTitle: "Ariza qoldirish",
      leadFormSubtitle: "Qo'ng'iroqni kuting, biz tez orada aloqaga chiqamiz",
      serviceTypeLabel: "Xizmat turi",
      serviceTypePlaceholder: "Xizmatni tanlang",
      messageLabel: "Xabar (ixtiyoriy)",
      messagePlaceholder: "Qo'shimcha ma'lumot..."
    },

    // Boiler Brand Page
    boiler: {
      titleSuffix: "katyol remonti Toshkentda",
      subtitle: "katyollari uchun ta'mirlash va texnik xizmat ko'rsatish",
      
      aboutTitle: "katyollari haqida",
      aboutNote: "Bizning mutaxassislarimiz {brand} brendining barcha modellarini professional darajada ta'mirlaydi va texnik xizmat ko'rsatadi.",
      
      problemsTitle: "katyollaridagi keng tarqalgan muammolar",
      problemNote: "Muammo ko'rdingizmi? Tashvishlanmang! Bizning tajribali ustalarimiz {brand} katyollaridagi har qanday nosozlikni tezda va sifatli bartaraf etadi.",
      
      servicesTitle: "uchun xizmatlarimiz",
      
      service1Title: "Bepul diagnostika",
      service1Desc: "{brand} katyolni to'liq tekshirish va nosozliklarni aniqlash",
      service2Title: "Professional ta'mirlash",
      service2Desc: "Barcha turdagi nosozliklarni tezkor va sifatli bartaraf etish",
      service3Title: "Ehtiyot qismlar",
      service3Desc: "Asl va sertifikatlangan ehtiyot qismlarni o'rnatish",
      service4Title: "Texnik xizmat",
      service4Desc: "Muntazam tozalash, sozlash va profilaktika ishlari",
      service5Title: "Tezkor xizmat",
      service5Desc: "24/7 ish tartibi, arizangizga 1 soat ichida javob",
      service6Title: "Kafolat",
      service6Desc: "Barcha ta'mirlash ishlariga 6 oylik kafolat beramiz",
      
      galleryTitle: "katyollar va ta'mirlash jarayoni",
      
      ctaTitle: "katyolingizni bugun ta'mirlang!",
      ctaSubtitle: "Professional ustalar, asl ehtiyot qismlar va 6 oylik kafolat",
      
      otherBrands: "Boshqa brendlarni ham ko'ring:"
    },

    // Footer
    footer: {
      description: "Toshkent shahrida katyol ta'mirlash va texnik xizmat ko'rsatish bo'yicha professional kompaniya.",
      quickLinks: "Tezkor havolalar",
      popularBrands: "Mashhur brendlar",
      contactInfo: "Aloqa ma'lumotlari",
      serviceArea: "Xizmat faqat Toshkent shahri bo'yicha",
      workingHours: "Ish vaqti: 24/7",
      copyright: "Barcha huquqlar himoyalangan."
    },

    // Individual Service Pages
    servicePages: {
      diagnostika: {
        title: "Katyol diagnostikasi",
        heroTitle: "Professional katyol diagnostikasi",
        heroSubtitle: "Katyolning ishdan chiqish sabablarini aniq aniqlash va to'liq diagnostika xizmati",
        price: "400,000 so'mdan",
        duration: "30-60 daqiqa",
        description: "Bizning tajribali mutaxassislarimiz katyolning barcha tizimlarini chuqur tekshiradilar. Zamonaviy diagnostika uskunalari yordamida nosozliklarni aniq aniqlaymiz va optimal ta'mirlash yo'lini tavsiya qilamiz.",
        features: [
          "Barcha katyol brendlarini diagnostika qilish",
          "Zamonaviy diagnostika uskunalari",
          "Aniq nosozlik aniqlash",
          "Yozma hisobot taqdim etish",
          "Ta'mirlash tavsiyalari",
          "Narx kalkulyatsiyasi"
        ],
        process: [
          "Katyolni tashqi ko'rikdan o'tkazish",
          "Elektr tizimlarini tekshirish",
          "Gaz va suv bosimini o'lchash",
          "Sensorlar va klapanlarni test qilish",
          "Xavfsizlik tizimlarini tekshirish",
          "Diagnostika hisobotini tayyorlash"
        ]
      },
      tozalash: {
        title: "Katyol tozalash va texnik xizmat",
        heroTitle: "Katyol tozalash va profilaktika",
        heroSubtitle: "Katyolni tozalash, sozlash va optimal ishlashini ta'minlash xizmati",
        price: "450,000 so'mdan",
        duration: "1-2 soat",
        description: "Muntazam tozalash katyolning samaradorligini oshiradi va xizmat muddatini uzaytiradi. Bizning ustalarimiz issiqlik almashinuvchi, yonish kamerasi va boshqa muhim qismlarni professional darajada tozalaydi.",
        features: [
          "Issiqlik almashinuvchi tozalash",
          "Yonish kamerasini tozalash",
          "Gaz gorelkasini tozalash",
          "Filtrlarni tozalash/almashtirish",
          "Suv tizimini tozalash",
          "Katyolni sozlash va optimizatsiya"
        ],
        process: [
          "Katyolni o'chirish va xavfsizlik tekshiruvi",
          "Issiqlik almashinuvchini olib tashlash",
          "Kimyoviy va mexanik tozalash",
          "Yonish kamerasini tozalash",
          "Qayta yig'ish va test",
          "Ishlash samaradorligini tekshirish"
        ]
      },
      "uch-klapan": {
        title: "Uch yo'nalishli klapan ta'mirlash",
        heroTitle: "Uch yo'nalishli klapan almashtirish",
        heroSubtitle: "Professional ta'mirlash va asl ehtiyot qismlar bilan almashtirish",
        price: "450,000 so'mdan",
        duration: "1-1.5 soat",
        description: "Uch yo'nalishli klapan issiq suv va isitish tizimi o'rtasida suv oqimini boshqaradi. Bu qism nosozligi natijasida katyol to'g'ri ishlamaydi. Bizning ustalarimiz asl qismlar bilan tezda almashtirib beradilar.",
        features: [
          "Asl ehtiyot qismlar ishlatish",
          "Barcha brendlar uchun xizmat",
          "Tezkor almashtirish",
          "Kafolat xizmati",
          "Test va sozlash",
          "Texnik maslahat"
        ],
        process: [
          "Nosozlikni diagnostika qilish",
          "Katyol brendiga mos qism tanlash",
          "Eski klapanni olib tashlash",
          "Yangi klapanni o'rnatish",
          "Tizimni test qilish",
          "Mijozga ko'rsatmalar berish"
        ]
      },
      turbina: {
        title: "Turbina ta'mirlash",
        heroTitle: "Turbo ventilyator ta'mirlash va almashtirish",
        heroSubtitle: "Chiqarish tizimi ta'mirlash va professional xizmat",
        price: "850,000 so'mdan",
        duration: "1.5-2.5 soat",
        description: "Turbo ventilyator yonish mahsulotlarini chiqaradi va toza havo olib keladi. Uning buzilishi xavfli bo'lishi mumkin. Professional ustalarimiz tezda ta'mirlab yoki almashtirib beradilar.",
        features: [
          "Ventilyator motorini ta'mirlash",
          "To'liq almashtirish xizmati",
          "Asl ehtiyot qismlar",
          "Shovqin muammolarini hal qilish",
          "Chiqarish tizimini tozalash",
          "Xavfsizlik tekshiruvi"
        ],
        process: [
          "Turbina nosozligini aniqlash",
          "Motor holatini baholash",
          "Ta'mirlash yoki almashtirish",
          "Chiqarish tizimini tozalash",
          "Test va kalibrovka",
          "Xavfsizlik tekshiruvi"
        ]
      },
      "issiqlik-almashgich": {
        title: "Issiqlik almashinuvchi almashtirish",
        heroTitle: "Issiqlik almashinuvchi xizmati",
        heroSubtitle: "Professional almashtirish va yangi issiqlik almashinuvchi o'rnatish",
        price: "1,300,000 so'mdan",
        duration: "2-3 soat",
        description: "Issiqlik almashinuvchi katyolning eng muhim qismi - u issiqlikni suvga o'tkazadi. Korroziya yoki tiqilish bo'lsa, almashtirish kerak. Yuqori sifatli qismlar bilan professional xizmat ko'rsatamiz.",
        features: [
          "Yuqori sifatli qismlar",
          "Barcha brendlar uchun",
          "Professional o'rnatish",
          "Tizimni yuvish",
          "Kafolat xizmati",
          "Samaradorlik kafolati"
        ],
        process: [
          "Eski almashgichni demontaj qilish",
          "Tizimni yuvish va tozalash",
          "Yangi almashgich o'rnatish",
          "Ulanishlarni tekshirish",
          "Bosim testi",
          "Samaradorlik tekshiruvi"
        ]
      },
      "bosim-sensori": {
        title: "Bosim sensori almashtirish",
        heroTitle: "Suv bosimi sensori xizmati",
        heroSubtitle: "Bosim datchigini almashtirish va ta'mirlash",
        price: "250,000 so'mdan",
        duration: "30-45 daqiqa",
        description: "Bosim sensori katyoldagi suv bosimini nazorat qiladi. Buzilgan sensor noto'g'ri ma'lumotlar beradi va katyol xavfsiz ishlamaydi. Tezda va sifatli almashtirish xizmati.",
        features: [
          "Tezkor almashtirish",
          "Asl sensorlar",
          "Barcha brendlar uchun",
          "Kalibrovka xizmati",
          "Kafolat",
          "Arzon narxlar"
        ],
        process: [
          "Sensor holatini tekshirish",
          "Mos qism tanlash",
          "Eski sensorni olib tashlash",
          "Yangi sensorni o'rnatish",
          "Kalibrovka qilish",
          "Test va tekshirish"
        ]
      },
      manostat: {
        title: "Manostat almashtirish",
        heroTitle: "Manostat (havo bosimi datchigi) xizmati",
        heroSubtitle: "Manostat almashtirish va ta'mirlash xizmati",
        price: "380,000 so'mdan",
        duration: "45 daqiqa - 1 soat",
        description: "Manostat havo bosimini nazorat qiladi va katyol xavfsiz ishlashini ta'minlaydi. Nosozlik bo'lsa, katyol yonmaydi yoki o'chib qoladi. Professional almashtirish xizmati.",
        features: [
          "Professional diagnostika",
          "Asl ehtiyot qismlar",
          "Tezkor xizmat",
          "Kafolat bilan",
          "Barcha brendlar",
          "Sifatli ishlash"
        ],
        process: [
          "Manostat diagnostikasi",
          "Havo trubkalarini tekshirish",
          "Yangi manostat o'rnatish",
          "Ulanishlarni tekshirish",
          "Katyolni ishga tushirish",
          "Xavfsizlik testi"
        ]
      },
      shoshilinch: {
        title: "Shoshilinch ta'mirlash 24/7",
        heroTitle: "Shoshilinch katyol ta'mirlash xizmati",
        heroSubtitle: "24/7 tezkor chiqish va muammoni bartaraf etish",
        price: "Kelishuv asosida",
        duration: "Tezkor chiqish",
        description: "Qish kechasi katyol buzilsa nima qilasiz? Bizga qo'ng'iroq qiling! 24/7 ishlayapmiz. O'sha kuni, o'sha soatda ustalar yetib keladi va muammoni hal qiladi.",
        features: [
          "24/7 ish tartibi",
          "30-60 daqiqada yetib kelish",
          "Tungi va dam olish kunlari",
          "Shoshilinch ehtiyot qismlar",
          "Professional ustalar",
          "Kafolat xizmati"
        ],
        process: [
          "Qo'ng'iroq qabul qilish",
          "Tezkor chiqish (30-60 daq)",
          "Muammoni tezda aniqlash",
          "Darhol ta'mirlash",
          "Test va tekshirish",
          "Kafolat berish"
        ]
      }
    },

    // Pricing Page
    pricing: {
      title: "Narxlar",
      heroTitle: "Xizmat narxlari",
      heroSubtitle: "Shaffof va adolatli narxlar. Diagnostika bepul!",
      tableHeaders: {
        service: "Xizmat turi",
        price: "Narxi",
        duration: "Vaqti"
      },
      note: "* Aniq narx diagnostikadan keyin aniqlanadi. Narxlar katyol brendiga qarab o'zgarishi mumkin.",
      categories: {
        diagnostics: "Diagnostika va tekshirish",
        repair: "Ta'mirlash xizmatlari",
        replacement: "Qismlarni almashtirish",
        maintenance: "Texnik xizmat"
      },
      cta: {
        title: "Aniq narxni bilmoqchimisiz?",
        subtitle: "Bepul diagnostika buyurtma qiling - usta kelib aniq narxni aytadi",
        button: "Bepul diagnostika"
      }
    },

    // Blog Page
    blog: {
      title: "Blog",
      heroTitle: "Foydali maqolalar",
      heroSubtitle: "Katyol haqida bilishingiz kerak bo'lgan hamma narsa",
      readMore: "Batafsil o'qish",
      categories: {
        tips: "Maslahatlar",
        maintenance: "Texnik xizmat",
        repair: "Ta'mirlash",
        selection: "Tanlash"
      },
      articles: [
        {
          id: 1,
          slug: "katyolni-qanday-saqlash",
          title: "Katyolni qanday to'g'ri saqlash kerak?",
          excerpt: "Katyolning uzoq va xavfsiz ishlashi uchun muntazam texnik xizmat ko'rsatish zarur. Bu maqolada asosiy qoidalarni o'rganasiz.",
          category: "maintenance",
          date: "2024-12-15"
        },
        {
          id: 2,
          slug: "katyol-tanlash",
          title: "Yangi katyol qanday tanlash kerak?",
          excerpt: "Uy uchun katyol tanlashda nimalarni e'tiborga olish kerak? Brendlar, quvvat va boshqa muhim omillar.",
          category: "selection",
          date: "2024-12-10"
        },
        {
          id: 3,
          slug: "qish-tayyorgarlik",
          title: "Qishga tayyorgarlik: katyolni tekshirish",
          excerpt: "Qish mavsumidan oldin katyolni qanday tekshirish va tayyorlash kerak? Professional maslahatlar.",
          category: "tips",
          date: "2024-12-05"
        }
      ],
      comingSoon: "Tez orada yangi maqolalar qo'shiladi!"
    }
  },

  ru: {
    // Navbar
    nav: {
      home: "Главная",
      about: "О нас",
      services: "Услуги",
      contact: "Контакты",
      boilers: "Котлы"
    },
    
    // Common
    common: {
      callNow: "Позвонить сейчас",
      onlineRequest: "Оставить онлайн заявку",
      learnMore: "Подробнее",
      orderNow: "Заказать сейчас",
      callMaster: "Вызвать мастера",
      submitRequest: "Отправить заявку",
      freeConsultation: "Получить бесплатную консультацию",
      telegram: "Telegram",
      instagram: "Instagram"
    },

    // Home Page
    home: {
      heroTitle: "Ремонт и техническое обслуживание котлов",
      heroSubtitle: "Быстрый и надежный ремонт котлов по Ташкенту",
      heroDescription: "Профессиональный ремонт, диагностика и техническое обслуживание котлов всех типов",
      
      advantagesTitle: "Почему именно мы?",
      advantagesSubtitle: "ServicePlyus - ваш надежный партнер в ремонте котлов",
      
      advantage1Title: "Большой опыт",
      advantage1Desc: "Ремонтируем котлы всех типов с опытом более 10 лет",
      advantage2Title: "Гарантийное обслуживание",
      advantage2Desc: "Предоставляем гарантию 6 месяцев на все работы",
      advantage3Title: "Быстрый сервис",
      advantage3Desc: "Работаем 24/7, ответим на вашу заявку в течение 1 часа",
      advantage4Title: "Справедливые цены",
      advantage4Desc: "Качественный сервис по самым выгодным ценам на рынке",
      
      brandsTitle: "Какие котлы мы ремонтируем",
      brandsSubtitle: "Профессиональный ремонт и техническое обслуживание всех популярных брендов",
      brandsMore: "И многие другие бренды...",
      
      ctaTitle: "Отремонтируйте котел уже сегодня!",
      ctaSubtitle: "Опыт более 10 лет, профессиональный подход, гарантийное обслуживание. Тысячи клиентов доверяют нам!",
      
      stats1: "1000+",
      stats1Label: "Довольных клиентов",
      stats2: "24/7",
      stats2Label: "Режим работы",
      stats3: "6 мес.",
      stats3Label: "Срок гарантии",
      
      // New Enhanced Sections
      averageRepairTime: "Среднее время ремонта 25-30 минут",
      paymentAfterRepair: "Оплата только после ремонта",
      discountWebsite: "Скидка при заказе через сайт 10%",
      
      pricingTitle: "Цены на услуги",
      pricingSubtitle: "По ремонту газовых настенных и напольных котлов",
      
      // Detailed Service Pricing
      servicePricing: {
        diagnostics: {
          name: "Диагностика и профилактика",
          price: "от 400 000 сум",
          desc: "Полная диагностика и проверка состояния котла"
        },
        cleaning: {
          name: "Чистка и настройка котла",
          price: "от 450 000 сум",
          desc: "Чистка теплообменника, камеры сгорания"
        },
        threeWayValve: {
          name: "Замена трёхходового клапана",
          price: "от 450 000 сум",
          desc: "Замена оригинальными запчастями"
        },
        turbine: {
          name: "Замена турбовентилятора",
          price: "от 850 000 сум",
          desc: "Ремонт системы вытяжки"
        },
        heatExchanger: {
          name: "Замена теплообменника",
          price: "от 1 300 000 сум",
          desc: "Установка нового теплообменника"
        },
        pressureSensor: {
          name: "Замена датчика давления воды",
          price: "от 250 000 сум",
          desc: "Замена датчика давления воды"
        },
        manostat: {
          name: "Замена маностата",
          price: "от 380 000 сум",
          desc: "Замена датчика давления воздуха"
        },
        emergency: {
          name: "Срочный ремонт (24/7)",
          price: "Договорная",
          desc: "Быстрый выезд и устранение проблемы"
        }
      },
      
      // Trust Signals / Why Choose Us
      trustTitle: "Почему выбирают нас?",
      trustSubtitle: "Наш сервисный центр по ремонту котлов лучший в Ташкенте",
      
      trust1Title: "Быстрый выезд",
      trust1Desc: "Мастера приедут в тот же день, за 30-60 минут",
      trust2Title: "Бесплатная диагностика",
      trust2Desc: "Специалисты оперативно определят источник неисправности",
      trust3Title: "Работаем 24/7",
      trust3Desc: "Наш сервисный центр готов принять ваш звонок круглосуточно",
      trust4Title: "Качественный ремонт",
      trust4Desc: "Отличное качество ремонта по приемлемой стоимости",
      
      // Testimonials
      testimonialsTitle: "Отзывы наших клиентов",
      testimonialsSubtitle: "Ниже мы собрали отзывы счастливых клиентов, которым наша компания уже помогла",
      
      testimonial1Name: "Алиса Апкарян",
      testimonial1Role: "HR в DD agency",
      testimonial1Text: "Хочу выразить благодарность компании за оперативность и профессионализм при ремонте моего котла. Работа была выполнена качественно и в срок. Теперь у меня снова комфортное и надежное отопление!",
      
      testimonial2Name: "Егор Ларин",
      testimonial2Role: "Менеджер проектов в Rixels",
      testimonial2Text: "Хочу отметить внимательное отношение к клиентам этой компании. Мне помогли с выбором оптимального варианта ремонта котла, профессионально проконсультировали и выполнили ремонт с высоким качеством. Был приятно удивлен скоростью работы и доступными ценами.",
      
      testimonial3Name: "Саша Коротких",
      testimonial3Role: "Креативный директор SoSoul magazine",
      testimonial3Text: "Никогда не оставляю отзывы, но тут не могла пройти мимо. Заказывала ремонт котла в этой компании и осталась очень довольна результатом. Ребята работали четко и аккуратно, они настоящие профессионалы своего дела.",
      
      testimonial4Name: "Дмитрий Соколов",
      testimonial4Role: "Директор строительной компании",
      testimonial4Text: "Работать с ServicePlyus - настоящее удовольствие. Специалисты знают свое дело на отлично, все работы выполнены в срок и качественно. Наш котел теперь работает безупречно, зимой не было никаких проблем.",
      
      testimonial5Name: "Мадина Рахимова",
      testimonial5Role: "Владелец ресторана",
      testimonial5Text: "Когда сломался котел в ресторане, ServicePlyus быстро помог. Сервис 24/7 - это очень важно. Они приехали вечером и за несколько часов решили проблему. Профессиональный подход и доступные цены. Рекомендую!",
      
      // Additional Services
      additionalServicesTitle: "Дополнительные услуги",
      service1: "Настройка работы котлов",
      service2: "Профилактические работы и чистка котлов",
      service3: "Обслуживание настенных и напольных котлов",
      service4: "Обслуживание двухконтурных котлов",
      service5: "Исправление утечек газа и воды",
      service6: "Починка платы управления"
    },

    // About Page
    about: {
      title: "О компании ServicePlyus",
      subtitle: "ServicePlyus - ведущая компания по ремонту котлов в Ташкенте. Наша команда состоит из профессиональных мастеров с опытом более 10 лет.",
      
      featuresTitle: "Наши преимущества",
      feature1: "Опыт более 10 лет",
      feature2: "Команда квалифицированных специалистов",
      feature3: "Ремонт всех брендов",
      feature4: "Гарантийное обслуживание",
      feature5: "Поддержка 24/7",
      feature6: "Быстрый сервис",
      
      whyUsTitle: "Почему клиенты выбирают нас?",
      whyUsSubtitle: "Качество, надежность и забота о клиентах - наши основные принципы",
      
      whyUs1Title: "Профессиональный подход",
      whyUs1Desc: "Индивидуальный подход к каждому клиенту и качественное обслуживание",
      whyUs2Title: "Надежный сервис",
      whyUs2Desc: "Более 95% наших клиентов рекомендуют нас своим друзьям",
      whyUs3Title: "Эффективные решения",
      whyUs3Desc: "Решаем проблемы в кратчайшие сроки и по оптимальным ценам",
      
      processTitle: "Как проходит работа?",
      processSubtitle: "Просто и эффективно - решаем проблему за 4 этапа",
      
      process1Title: "Звонок",
      process1Desc: "Позвоните нам или оставьте онлайн заявку",
      process2Title: "Диагностика",
      process2Desc: "Мастер приедет, проверит котел и определит проблему",
      process3Title: "Ремонт",
      process3Desc: "Быстро и качественно выполняем ремонтные работы",
      process4Title: "Гарантия",
      process4Desc: "Предоставляем гарантию 6 месяцев на все работы",
      
      ctaTitle: "Доверьте ваш котел профессиональному мастеру",
      ctaSubtitle: "Быстрый сервис по Ташкенту, надежный ремонт и гарантия"
    },

    // Services Page
    services: {
      title: "Наши услуги",
      subtitle: "Выполняем все виды ремонта и технического обслуживания котлов на профессиональном уровне",
      
      service1Title: "Диагностика котла",
      service1Desc: "Точное определение причин неисправности и полная диагностика котла",
      service2Title: "Ремонт котла",
      service2Desc: "Быстрый и качественный ремонт всех видов неисправностей, запуск котла",
      service3Title: "Замена запчастей",
      service3Desc: "Надежная замена оригинальными запасными частями",
      service4Title: "Годовое техническое обслуживание",
      service4Desc: "Чистка, настройка и обеспечение оптимальной работы котла",
      service5Title: "Установка и настройка",
      service5Desc: "Профессиональная установка и запуск новых котлов",
      
      includesTitle: "Что включают наши услуги?",
      includesSubtitle: "Каждая услуга выполняется полно и профессионально",
      
      include1Title: "Бесплатная диагностика",
      include1Desc: "Полная проверка котла и определение проблемы",
      include2Title: "Быстрый сервис",
      include2Desc: "Ответим на вашу заявку в течение 1 часа и быстро отремонтируем",
      include3Title: "Оригинальные запчасти",
      include3Desc: "Используем только сертифицированные и оригинальные детали",
      include4Title: "Профессиональные мастера",
      include4Desc: "Квалифицированные специалисты с опытом более 10 лет",
      include5Title: "Гарантийное обслуживание",
      include5Desc: "Гарантия 6 месяцев на все ремонтные работы",
      include6Title: "Доступные цены",
      include6Desc: "Самые выгодные и справедливые цены на рынке",
      
      pricingTitle: "Цены на услуги",
      pricingSubtitle: "Точные цены определяются после диагностики. Диагностика бесплатная!",
      averagePrices: "Средние цены",
      
      price1: "Диагностика",
      price1Value: "Бесплатно",
      price2: "Чистка и настройка",
      price2Value: "от 300 000 сум",
      price3: "Мелкий ремонт",
      price3Value: "от 400 000 сум",
      price4: "Крупный ремонт",
      price4Value: "от 700 000 сум",
      
      getPrice: "Узнать точную цену",
      getPriceDesc: "Каждый случай индивидуален. После бесплатной диагностики назовем точную цену и объем работ.",
      
      ctaTitle: "Отремонтируйте котел сегодня!",
      ctaSubtitle: "Позвоните и получите бесплатную диагностику"
    },

    // Contact Page
    contact: {
      title: "Свяжитесь с нами",
      subtitle: "Позвоните для ремонта котла или оставьте заявку. Работаем 24/7!",
      
      contactInfo: "Контактная информация",
      phoneTitle: "Номер телефона",
      phoneSubtitle: "Позвоните прямо сейчас",
      
      locationTitle: "Зона обслуживания",
      locationText: "Обслуживание только по городу Ташкент",
      locationSubtext: "По всем районам",
      
      hoursTitle: "Режим работы",
      hoursText: "24/7",
      hoursSubtext: "Работаем и в выходные дни",
      
      socialTitle: "В социальных сетях",
      
      formTitle: "Оставить заявку",
      formSubtitle: "Оставьте вашу заявку, мы свяжемся с вами в ближайшее время",
      
      nameLabel: "Ваше имя",
      namePlaceholder: "Введите ваше полное имя",
      phoneLabel: "Номер телефона",
      phonePlaceholder: "+998 90 123 45 67",
      
      submitting: "Отправка...",
      submitButton: "Отправить заявку",
      submitNote: "После отправки заявки мы свяжемся с вами в течение 15 минут",
      
      quickCall: "Или позвоните напрямую",
      
      banner1: "1 час",
      banner1Label: "Время ответа",
      banner2: "24/7",
      banner2Label: "Всегда на связи",
      banner3: "Бесплатно",
      banner3Label: "Диагностика",
      
      // Lead Form
      leadFormTitle: "Оставить заявку",
      leadFormSubtitle: "Ожидайте звонок, мы скоро свяжемся с вами",
      serviceTypeLabel: "Тип услуги",
      serviceTypePlaceholder: "Выберите услугу",
      messageLabel: "Сообщение (необязательно)",
      messagePlaceholder: "Дополнительная информация..."
    },

    // Boiler Brand Page
    boiler: {
      titleSuffix: "ремонт котлов в Ташкенте",
      subtitle: "котлов и техническое обслуживание",
      
      aboutTitle: "О котлах",
      aboutNote: "Наши специалисты профессионально ремонтируют и обслуживают все модели бренда {brand}.",
      
      problemsTitle: "Частые проблемы котлов",
      problemNote: "Обнаружили проблему? Не беспокойтесь! Наши опытные мастера быстро и качественно устранят любую неисправность котлов {brand}.",
      
      servicesTitle: "Наши услуги для",
      
      service1Title: "Бесплатная диагностика",
      service1Desc: "Полная проверка котла {brand} и выявление неисправностей",
      service2Title: "Профессиональный ремонт",
      service2Desc: "Быстрое и качественное устранение всех видов неисправностей",
      service3Title: "Запасные части",
      service3Desc: "Установка оригинальных и сертифицированных запчастей",
      service4Title: "Техническое обслуживание",
      service4Desc: "Регулярная чистка, настройка и профилактические работы",
      service5Title: "Быстрый сервис",
      service5Desc: "Режим работы 24/7, ответим на вашу заявку в течение 1 часа",
      service6Title: "Гарантия",
      service6Desc: "Предоставляем гарантию 6 месяцев на все ремонтные работы",
      
      galleryTitle: "Котлы и процесс ремонта",
      
      ctaTitle: "Отремонтируйте ваш котел {brand} сегодня!",
      ctaSubtitle: "Профессиональные мастера, оригинальные запчасти и гарантия 6 месяцев",
      
      otherBrands: "Смотрите также другие бренды:"
    },

    // Footer
    footer: {
      description: "Профессиональная компания по ремонту и техническому обслуживанию котлов в городе Ташкент.",
      quickLinks: "Быстрые ссылки",
      popularBrands: "Популярные бренды",
      contactInfo: "Контактная информация",
      serviceArea: "Обслуживание только по городу Ташкент",
      workingHours: "Режим работы: 24/7",
      copyright: "Все права защищены."
    },

    // Individual Service Pages (Russian)
    servicePages: {
      diagnostika: {
        title: "Диагностика котла",
        heroTitle: "Профессиональная диагностика котла",
        heroSubtitle: "Точное определение причин неисправности и полная диагностика",
        price: "от 400 000 сум",
        duration: "30-60 минут",
        description: "Наши опытные специалисты проведут глубокую проверку всех систем котла. С помощью современного диагностического оборудования мы точно определим неисправности и предложим оптимальный способ ремонта.",
        features: [
          "Диагностика всех брендов котлов",
          "Современное диагностическое оборудование",
          "Точное определение неисправности",
          "Письменный отчет",
          "Рекомендации по ремонту",
          "Калькуляция стоимости"
        ],
        process: [
          "Внешний осмотр котла",
          "Проверка электрических систем",
          "Измерение давления газа и воды",
          "Тестирование датчиков и клапанов",
          "Проверка систем безопасности",
          "Подготовка диагностического отчета"
        ]
      },
      tozalash: {
        title: "Чистка и обслуживание котла",
        heroTitle: "Чистка и профилактика котла",
        heroSubtitle: "Чистка, настройка и обеспечение оптимальной работы",
        price: "от 450 000 сум",
        duration: "1-2 часа",
        description: "Регулярная чистка повышает эффективность котла и продлевает срок его службы. Наши мастера профессионально очистят теплообменник, камеру сгорания и другие важные компоненты.",
        features: [
          "Чистка теплообменника",
          "Чистка камеры сгорания",
          "Чистка газовой горелки",
          "Чистка/замена фильтров",
          "Промывка водяной системы",
          "Настройка и оптимизация"
        ],
        process: [
          "Отключение котла и проверка безопасности",
          "Демонтаж теплообменника",
          "Химическая и механическая чистка",
          "Чистка камеры сгорания",
          "Сборка и тестирование",
          "Проверка эффективности работы"
        ]
      },
      "uch-klapan": {
        title: "Ремонт трёхходового клапана",
        heroTitle: "Замена трёхходового клапана",
        heroSubtitle: "Профессиональный ремонт и замена оригинальными запчастями",
        price: "от 450 000 сум",
        duration: "1-1.5 часа",
        description: "Трёхходовой клапан управляет потоком воды между системой отопления и горячей водой. При его неисправности котел работает неправильно. Наши мастера быстро заменят его оригинальными деталями.",
        features: [
          "Использование оригинальных запчастей",
          "Обслуживание всех брендов",
          "Быстрая замена",
          "Гарантийное обслуживание",
          "Тестирование и настройка",
          "Техническая консультация"
        ],
        process: [
          "Диагностика неисправности",
          "Подбор детали по бренду котла",
          "Демонтаж старого клапана",
          "Установка нового клапана",
          "Тестирование системы",
          "Инструктаж клиента"
        ]
      },
      turbina: {
        title: "Ремонт турбины",
        heroTitle: "Ремонт и замена турбовентилятора",
        heroSubtitle: "Ремонт системы вытяжки и профессиональное обслуживание",
        price: "от 850 000 сум",
        duration: "1.5-2.5 часа",
        description: "Турбовентилятор отводит продукты сгорания и подает чистый воздух. Его поломка может быть опасной. Наши профессиональные мастера быстро отремонтируют или заменят его.",
        features: [
          "Ремонт двигателя вентилятора",
          "Полная замена",
          "Оригинальные запчасти",
          "Устранение проблем с шумом",
          "Чистка системы вытяжки",
          "Проверка безопасности"
        ],
        process: [
          "Определение неисправности турбины",
          "Оценка состояния двигателя",
          "Ремонт или замена",
          "Чистка системы вытяжки",
          "Тестирование и калибровка",
          "Проверка безопасности"
        ]
      },
      "issiqlik-almashgich": {
        title: "Замена теплообменника",
        heroTitle: "Обслуживание теплообменника",
        heroSubtitle: "Профессиональная замена и установка нового теплообменника",
        price: "от 1 300 000 сум",
        duration: "2-3 часа",
        description: "Теплообменник - важнейшая часть котла, передающая тепло воде. При коррозии или засорении требуется замена. Мы оказываем профессиональные услуги с высококачественными деталями.",
        features: [
          "Высококачественные детали",
          "Для всех брендов",
          "Профессиональная установка",
          "Промывка системы",
          "Гарантийное обслуживание",
          "Гарантия эффективности"
        ],
        process: [
          "Демонтаж старого теплообменника",
          "Промывка и чистка системы",
          "Установка нового теплообменника",
          "Проверка соединений",
          "Тест давления",
          "Проверка эффективности"
        ]
      },
      "bosim-sensori": {
        title: "Замена датчика давления",
        heroTitle: "Обслуживание датчика давления воды",
        heroSubtitle: "Замена и ремонт датчика давления",
        price: "от 250 000 сум",
        duration: "30-45 минут",
        description: "Датчик давления контролирует давление воды в котле. Неисправный датчик дает неверные показания, и котел работает небезопасно. Быстрая и качественная замена.",
        features: [
          "Быстрая замена",
          "Оригинальные датчики",
          "Для всех брендов",
          "Калибровка",
          "Гарантия",
          "Доступные цены"
        ],
        process: [
          "Проверка состояния датчика",
          "Подбор подходящей детали",
          "Демонтаж старого датчика",
          "Установка нового датчика",
          "Калибровка",
          "Тестирование и проверка"
        ]
      },
      manostat: {
        title: "Замена маностата",
        heroTitle: "Обслуживание маностата (датчика давления воздуха)",
        heroSubtitle: "Замена и ремонт маностата",
        price: "от 380 000 сум",
        duration: "45 мин - 1 час",
        description: "Маностат контролирует давление воздуха и обеспечивает безопасную работу котла. При неисправности котел не зажигается или отключается. Профессиональная замена.",
        features: [
          "Профессиональная диагностика",
          "Оригинальные запчасти",
          "Быстрое обслуживание",
          "С гарантией",
          "Все бренды",
          "Качественная работа"
        ],
        process: [
          "Диагностика маностата",
          "Проверка воздушных трубок",
          "Установка нового маностата",
          "Проверка соединений",
          "Запуск котла",
          "Тест безопасности"
        ]
      },
      shoshilinch: {
        title: "Срочный ремонт 24/7",
        heroTitle: "Срочный ремонт котла",
        heroSubtitle: "Быстрый выезд и устранение проблемы 24/7",
        price: "Договорная",
        duration: "Быстрый выезд",
        description: "Что делать, если котел сломался зимней ночью? Звоните нам! Работаем 24/7. В тот же день, в тот же час мастера приедут и решат проблему.",
        features: [
          "Режим работы 24/7",
          "Приезд за 30-60 минут",
          "Ночью и в выходные",
          "Срочные запчасти",
          "Профессиональные мастера",
          "Гарантийное обслуживание"
        ],
        process: [
          "Прием звонка",
          "Быстрый выезд (30-60 мин)",
          "Быстрое определение проблемы",
          "Немедленный ремонт",
          "Тестирование и проверка",
          "Предоставление гарантии"
        ]
      }
    },

    // Pricing Page (Russian)
    pricing: {
      title: "Цены",
      heroTitle: "Цены на услуги",
      heroSubtitle: "Прозрачные и справедливые цены. Диагностика бесплатно!",
      tableHeaders: {
        service: "Вид услуги",
        price: "Цена",
        duration: "Время"
      },
      note: "* Точная цена определяется после диагностики. Цены могут варьироваться в зависимости от бренда котла.",
      categories: {
        diagnostics: "Диагностика и проверка",
        repair: "Услуги ремонта",
        replacement: "Замена деталей",
        maintenance: "Техническое обслуживание"
      },
      cta: {
        title: "Хотите узнать точную цену?",
        subtitle: "Закажите бесплатную диагностику - мастер приедет и назовет точную стоимость",
        button: "Бесплатная диагностика"
      }
    },

    // Blog Page (Russian)
    blog: {
      title: "Блог",
      heroTitle: "Полезные статьи",
      heroSubtitle: "Всё, что вам нужно знать о котлах",
      readMore: "Читать далее",
      categories: {
        tips: "Советы",
        maintenance: "Обслуживание",
        repair: "Ремонт",
        selection: "Выбор"
      },
      articles: [
        {
          id: 1,
          slug: "katyolni-qanday-saqlash",
          title: "Как правильно обслуживать котел?",
          excerpt: "Для долгой и безопасной работы котла необходимо регулярное техническое обслуживание. В этой статье вы узнаете основные правила.",
          category: "maintenance",
          date: "2024-12-15"
        },
        {
          id: 2,
          slug: "katyol-tanlash",
          title: "Как выбрать новый котел?",
          excerpt: "На что обратить внимание при выборе котла для дома? Бренды, мощность и другие важные факторы.",
          category: "selection",
          date: "2024-12-10"
        },
        {
          id: 3,
          slug: "qish-tayyorgarlik",
          title: "Подготовка к зиме: проверка котла",
          excerpt: "Как проверить и подготовить котел перед зимним сезоном? Профессиональные советы.",
          category: "tips",
          date: "2024-12-05"
        }
      ],
      comingSoon: "Скоро будут добавлены новые статьи!"
    }
  }
};

// Russian translations for boiler brands (descriptions and problems)
export const boilerTranslationsRu = {
  airfel: {
    description: "Airfel - высококачественные котлы турецкого производства. Известны долгим сроком службы и надежностью.",
    problems: [
      "Падение давления",
      "Засорение теплообменника",
      "Неисправность электроники",
      "Не работает водяной насос"
    ]
  },
  akfa: {
    description: "Akfa - популярный турецкий бренд котлов в Узбекистане. Адаптирован под местные климатические условия.",
    problems: [
      "Замена запальника",
      "Поломка циркуляционного насоса",
      "Неисправность электронной платы",
      "Поломка газового клапана"
    ]
  },
  atlantic: {
    description: "Atlantic - французский производитель. Современные технологии и экологически чистая работа.",
    problems: [
      "Замена термоблока",
      "Поломка датчика давления",
      "Проблема с утечкой воды",
      "Ошибки на экране"
    ]
  },
  baxi: {
    description: "Baxi - итальянские премиум котлы. Выделяются высокой эффективностью и красивым дизайном.",
    problems: [
      "Чистка теплообменника",
      "Замена трехходового клапана",
      "Давление расширительного бака",
      "Неисправность турбовентилятора"
    ]
  },
  baymak: {
    description: "Baymak - турецкие котлы. Простое обслуживание и надежная работа.",
    problems: [
      "Замена газового клапана",
      "Ремонт печатной платы",
      "Замена двигателя вентилятора",
      "Проблемы с давлением воды"
    ]
  },
  ferroli: {
    description: "Ferroli - итальянские качественные котлы. Современные конденсационные технологии.",
    problems: [
      "Чистка камеры сгорания",
      "Замена NTC датчиков",
      "Ремонт переключающего клапана",
      "Изменение давления"
    ]
  },
  rulls: {
    description: "Rulls - современный турецкий бренд. Сочетание доступной цены и хорошего качества.",
    problems: [
      "Проблема розжига запальника",
      "Утечка воды",
      "Ошибки на экране",
      "Ремонт циркуляции"
    ]
  },
  kiturami: {
    description: "Kiturami - высокотехнологичные котлы корейского производства. Устойчивы к холодному климату.",
    problems: [
      "Диагностика электроники",
      "Замена газового прессостата",
      "Чистка водяного фильтра",
      "Замена предохранительного клапана"
    ]
  },
  unit: {
    description: "Unit - недорогие и надежные турецкие котлы. Лидеры в среднем ценовом сегменте.",
    problems: [
      "Неисправность манометра",
      "Шум насоса",
      "Замена термостата",
      "Проблема удаления воздуха"
    ]
  },
  viessmann: {
    description: "Viessmann - немецкие премиум котлы. Максимальная эффективность и долговечность.",
    problems: [
      "Чистка лямбда-зонда",
      "Настройка модуляционного клапана",
      "Дренаж конденсата",
      "Ошибки умной диагностики"
    ]
  },
  everel: {
    description: "Everel - турецкий бренд. Простой дизайн и легкое обслуживание.",
    problems: [
      "Диагностика газового клапана",
      "Ремонт водяного насоса",
      "Проблемы с экраном",
      "Замена запальников"
    ]
  },
  thermona: {
    description: "Thermona - чешские котлы. Европейское качество и надежная работа.",
    problems: [
      "Чистка теплообменника",
      "Замена тепловой защиты",
      "Настройка газового давления",
      "Неисправность автоматики"
    ]
  },
  navien: {
    description: "Navien - премиум котлы из Южной Кореи. С современными умными технологиями.",
    problems: [
      "Настройка умного управления",
      "Датчик потока воды",
      "Замена датчика пламени",
      "Ремонт печатной платы"
    ]
  },
  orbek: {
    description: "Orbek - турецкие котлы. Популярны на местном рынке и доступные запчасти.",
    problems: [
      "Замена запальника",
      "Восстановление давления воды",
      "Ремонт вентилятора",
      "Диагностика электроники"
    ]
  }
};
